export const NODE_LEVEL = {
    ROOT: 'root',
    BRANCH: 'branch',
    CHILD: 'child'
}

export const FOLDER_TYPE = {
    SERVICE_TYPE: 'serviceType',
    CONTENT_FOLDER: 'contentFolder',
    CONTENT_INFO: 'contentInfo',
    PUBLISHING_PLANS: 'publishingPlan'
}
